import React, { useCallback } from 'react';

import PropTypes from 'prop-types';

import { noop } from 'ui-components/default-props/noop';

import { WalletCreditCardInfo } from '../../../../components/wallet-credit-card-info';
import { FORM_REQUIREMENTS } from '../../../../utilities/constants';
import { useWalletRegistrationErrorContext } from '../../contexts/wallet-registration-error-context';
import { useWalletRegistrationFormContext } from '../../contexts/wallet-registration-form-context';

const initialEmptyCreditCardInfo = {};

export const WalletRegistrationCreditCard = ({ markFormComplete = noop }) => {
  const { walletForm, updateWalletForm, submittingRegistration } = useWalletRegistrationFormContext();
  const { validationErrors, showAllErrors } = useWalletRegistrationErrorContext();

  const onChange = useCallback(
    ({ propertyName, value }) => {
      updateWalletForm([FORM_REQUIREMENTS.PAYMENT_METHOD, FORM_REQUIREMENTS.CREDIT_CARD, propertyName], value);
    },
    [updateWalletForm],
  );

  const onValidationChange = useCallback(
    (isValid) => {
      markFormComplete(FORM_REQUIREMENTS.CREDIT_CARD, isValid);
    },
    [markFormComplete],
  );

  return (
    <WalletCreditCardInfo
      currency={walletForm.CurrencyCode}
      disabled={submittingRegistration}
      errors={validationErrors?.[FORM_REQUIREMENTS.PAYMENT_METHOD]?.[FORM_REQUIREMENTS.CREDIT_CARD]}
      onChange={onChange}
      onValidationChange={onValidationChange}
      paymentInfo={walletForm[FORM_REQUIREMENTS.PAYMENT_METHOD]?.[FORM_REQUIREMENTS.CREDIT_CARD] || initialEmptyCreditCardInfo}
      showAllErrors={showAllErrors}
    />
  );
};

WalletRegistrationCreditCard.propTypes = {
  markFormComplete: PropTypes.func,
};
